import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { API_COLLECTION_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class CollectionService {
  static postCollection = async data => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + '/workList/list', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static createEvents = async data => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + '/events', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static createLawyerEvents = async data => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + '/legalProcess', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static patchEvents = async data => {
    try {
      const result = await HTTPHandler.patch(API_COLLECTION_URL + '/events', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static updateLegalAssignTo = async data => {
    try {
      const result = await HTTPHandler.patch(API_COLLECTION_URL + '/updateLegalAssignTo', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static patchLawyerEvents = async data => {
    try {
      const result = await HTTPHandler.patch(API_COLLECTION_URL + '/legalProcess', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static sendEmail = async id => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + `/email/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static createCall = async data => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + '/workList/call', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getDocs = async data => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + '/contracts/docs', data, {}, { responseType: 'blob' })
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getBsFile = async id => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/files/downloadBsFile/${id}`, { responseType: 'blob' })
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static uploadFile = async data => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + '/files/uploadFile', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static saveWlFile = async data => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + '/files/saveWorkListFile', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static addAddress = async data => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + '/workList/address', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getById = async id => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/workList/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getCalls = async id => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/workList/calls/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getCallAudio = async id => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/workList/calls/call/${id}`, { responseType: 'blob' })
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getWlFiles = async id => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/files/workList/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static deleteWlFile = async data => {
    try {
      const result = await HTTPHandler.delete(API_COLLECTION_URL + `/files/delete/`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getFileTypes = async () => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/files/collectionFileTypes`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getShfSubdivisions = async () => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/contracts/shfSubdivisions`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getStatuses = async () => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/events/statuses`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static findByContract = async contractId => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/events/findByContract/${contractId}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getLawyerStatuses = async () => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/legalProcess/statuses`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static updateListAssignTo = async data => {
    try {
      const result = await HTTPHandler.patch(API_COLLECTION_URL + `/workList/updateListAssignTo`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static updateComments = async data => {
    try {
      const result = await HTTPHandler.patch(API_COLLECTION_URL + `/workList/comment`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static addEmailPhone = async data => {
    try {
      const result = await HTTPHandler.patch(API_COLLECTION_URL + `/workList`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getFinanceTableData = async (data, type) => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + `/contracts/${type}`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getContractHistory = async id => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/clients/clientsContractHistory/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getAddresses = async id => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/clients/addresses/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getPhoneNumbers = async phoneNumber => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/clients/phoneNumbers/${phoneNumber}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getContacts = async id => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/clients/contacts/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static createApplicationMultipart = async formData => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + `/applications`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getApplications = async (params = {}) => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + '/applications/list', params)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getApplicationById = async id => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/applications/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static completeApplication = async id => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + `/applications/${id}/complete`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static rejectApplication = async (id, reason) => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + `/applications/${id}/reject`, { reason })
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static resubmitApplicationMultipart = async (id, formData) => {
    try {
      const result = await HTTPHandler.post(API_COLLECTION_URL + `/applications/${id}/resubmit`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static exportApplications = async (payload = {}) => {
    try {
      const result = await HTTPHandler.post(
        API_COLLECTION_URL + `/applications/export`,
        payload,
        {},
        { responseType: 'blob' }
      )
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static exportAllWorkList = async (params = {}) => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/workList/export`, { params, responseType: 'blob' })
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static exportWorkListResults = async (params = {}) => {
    try {
      const result = await HTTPHandler.get(API_COLLECTION_URL + `/workList/results`, { params, responseType: 'blob' })
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
}
